module.exports = __webpack_public_path__ + "img/ic_module_item_img2.0e7e1e7e.png";